import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, IconButton, Toolbar } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './AccountPopover';
import ContactsPopover from './ContactsPopover';
import ContentSearch from './ContentSearch';
import LanguagePopover from './LanguagePopover';
import Logo from '../Logo';
import NotificationsPopover from './NotificationsPopover';
import logo from '../../images/logo-white.png'
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, LinkedinShareButton, LinkedinIcon,
   PinterestShareButton, PinterestIcon,   WhatsappShareButton,   WhatsappIcon, EmailShareButton, EmailIcon }from  "react-share";


const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  zIndex: theme.zIndex.drawer + 100
}));

const title = `${document.title} | Advanced Dontpad`;
const url = window.location.href;
    const iconSize = 30;

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <IconButton
          color="inherit"
          onClick={onSidebarMobileOpen}
          sx={{
            display: {
              lg: 'none'
            }
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <RouterLink to="/">
          <img src={logo}></img>
        </RouterLink>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
          <Box sx={{ ml: 1 }}>
          <FacebookShareButton url={url} quote={title} className="share-button">
          <FacebookIcon size={iconSize} round />
         </FacebookShareButton>
         <TwitterShareButton url={url} title={title} className="share-button">
          <TwitterIcon size={iconSize} round />
         </TwitterShareButton>
         <LinkedinShareButton url={'https://dot3qavapfofj.cloudfront.net'} summary={"Northcode"} className="share-button">
        <LinkedinIcon size={iconSize} round />
        </LinkedinShareButton>
        <WhatsappShareButton url={'https://dot3qavapfofj.cloudfront.net'} title={"Northcode"} className="share-button">
        <WhatsappIcon size={iconSize} round />
        </WhatsappShareButton>
        <EmailShareButton url={'https://dot3qavapfofj.cloudfront.net'} body={"Northcode"} className="share-button">
        <EmailIcon size={iconSize} round />
        </EmailShareButton>
      
         </Box >
        <LanguagePopover />
      
        <Box sx={{ ml: 1 }}>
          <NotificationsPopover />
        </Box>
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
